<template>
  <div class="treeNode">
    <Icon v-if="data.children && data.children.length" style="cursor: pointer" :type="data.expand ? 'ios-arrow-down' : 'ios-arrow-forward'" @click="expand" />
    <Icon v-else style="width: 12px"></Icon>

    <Checkbox
      :disabled="data.disabled ? true : false"
      :value="value.includes(data.value)"
      :size="size"
      v-if="(parentNodeAllow && !data.disable) || (!parentNodeAllow && (!data.children || !data.children.length))"
      @click.native.prevent="check"
      :indeterminate="childrenCheck(data)"
    ></Checkbox>
    <span :class="data.status == 1 ? 'dian' : 'red'" v-if="data.status"></span>
    <span class="province" v-show="data.orgType == 2">省</span>
    <span class="city" v-show="data.orgType == 3">市</span>
    <span class="area" v-show="data.orgType == 4">区</span>
    <span class="channel" v-show="data.orgType == 5">渠</span>
    <span v-html="addMarking(data.label)"></span>

    <treeNode
      v-show="data.expand"
      v-for="(item, index) in data.children"
      :key="index"
      :treeData="treeData"
      :data="item"
      :size="size"
      :value="value"
      :multiple="multiple"
      :selectAllChildren="selectAllChildren ? selectAllChildren : false"
      :parentNodeAllow="parentNodeAllow"
      :keyWord="keyWord"
      @check="$emit('check', $event)"
    />
  </div>
</template>

<script>
export default {
  name: 'TreeNode',
  props: ['data', 'size', 'value', 'multiple', 'parentNodeAllow', 'keyWord', 'treeData', 'selectAllChildren'],
  data() {
    return {
      values: []
    };
  },
  mounted() {
    // console.log(this.value);
    // console.log(this.data.value)
  },
  methods: {
    childrenCheck(data) {
      if (!this.value || !data || this.value.includes(data.value) || !data.children) {
        return false;
      }
      let allArr = [];
      let checkArr = [];
      data.children.forEach(item => {
        allArr.push(item.value);
        if (this.value.includes(item.value)) {
          checkArr.push(item.value);
        }
      });
      return checkArr.length != 0 && allArr.length != checkArr.length;
    },
    expand() {
      if (Object.keys(this.data).includes('expand')) {
        this.data.expand = !this.data.expand;
      } else {
        this.$set(this.data, 'expand', !this.data.expand);
      }
    },
    //选中子机构
    getValues(datas, isAll = false) {
      for (var i in datas) {
        if (!this.value.includes(datas[i].value) || isAll) {
          this.values.push(datas[i].value);
        }
        if (datas[i].children && datas[i].children.length > 0) {
          this.getValues(datas[i].children, isAll);
        }
      }
    },
    check() {
      let value = this.data.value;
      let index = this.value.indexOf(value);
      if (index > -1) {
        this.value.splice(index, 1);
        if (this.selectAllChildren) {
          this.values = [];
          //添加所有子id
          if (this.data.children && this.data.children.length > 0) {
            this.getValues(this.data.children, true);
          }
          this.values.forEach(item => {
            const index = this.value.indexOf(item);
            if (index > -1) {
              this.value.splice(index, 1);
            }
          });
        }
      } else {
        !this.multiple && this.value.splice(0, this.value.length);
        this.value.push(value);
        if (this.selectAllChildren) {
          this.values = [];
          //添加所有子id
          if (this.data.children && this.data.children.length > 0) {
            this.getValues(this.data.children);
          }
          this.value.push.apply(this.value, this.values);
        }
      }
      this.$emit('check', [this.data, this.value]);
    },
    addMarking(html) {
      return this.keyWord ? html.split(this.keyWord).join(`<font color="red">${this.keyWord}</font>`) : html;
    },
    addParents(data) {
      while (data.length) {
        let parent = data.pop();
        let parentNode = this.getParentNode(parent);
        if (parentNode && parentNode.children.every(item => this.value.includes(item.value))) {
          this.value.push(parent);
        }
      }
    },
    getParentNode(value) {
      let res;
      (function loop(data) {
        for (let i = 0, len = data.length; i < len; i++) {
          if (data[i].value === value) {
            res = data[i];
            break;
          } else if (!res && data[i].children && data[i].children.length) {
            loop(data[i].children);
          }
        }
      })(this.treeData);
      return res;
    },
    remove(data) {
      data.forEach(item => {
        let index = this.value.indexOf(item.value);
        if (index > -1) {
          this.value.splice(index, 1);
        } else {
          this.value.push(item.value);
        }
        if (item.children && item.children.length) {
          this.remove(item.children);
        }
      });
    },
    add(data) {
      data.forEach(item => {
        let index = this.value.indexOf(item.value);
        if (index === -1) {
          this.value.push(item.value);
        }
        if (item.children && item.children.length) {
          this.add(item.children);
        }
      });
    }
  },
  watch: {}
};
</script>

<style scoped lang="less">
.treeNode {
  padding-left: 18px;
  margin: 3px 0;
  .dian {
    display: inline-block;
    margin-bottom: 2px;
    width: 5px;
    height: 5px;
    background: #35bf3f;
    border-radius: 50%;
  }
  .red {
    display: inline-block;
    margin-bottom: 2px;
    width: 5px;
    height: 5px;
    border-radius: 50%;
    background: #e3461f;
  }
  .province {
    font-size: 12px;
    border: 1px solid #e36767;
    color: #e36767;
    border-radius: 2px;
    padding: 2px 2px;
    margin-right: 5px;
  }
  .city {
    font-size: 12px;
    border: 1px solid #e09b60;
    color: #e09b60;
    border-radius: 2px;
    padding: 2px 2px;
    margin-right: 5px;
  }
  .area {
    font-size: 12px;
    border: 1px solid #6389c9;
    color: #6389c9;
    border-radius: 2px;
    padding: 2px 2px;
    margin-right: 5px;
  }
  .channel {
    font-size: 12px;
    border: 1px solid #6fb277;
    color: #6fb277;
    border-radius: 2px;
    padding: 2px 2px;
    margin-right: 5px;
  }
}
</style>
